(function () {
  'use strict';

  /* @ngdoc object
   * @name parcels.selection
   * @description
   *
   */
  angular
    .module('parcels.selection', [
      'ui.router'
    ]);
}());
